import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions, URLSearchParams } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class FollowUpCommunicationService {

    paginationData: any = {};
    selectedLimit: any;
    selectedOffset: any;
    search: any;
    filter: any;
    url: any;
    patient: any = {};

    constructor(
        private _basewebservice: BaseWebService
    ) { }


    /**
         * Function for get history
         */
    followUpHistory(id: any) {
        return this._basewebservice.request("v1/patient_relapse_communications/" + id + "/history/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
   * Service Function for Follow Up Filter
   */

    followUpFilterService(filter: any, search: any, pageItems: any, offset: any, patientId: any, sortParam: any, order: any) {
        this.url = "v1/patient_relapse_communications/";
        if (filter.location === undefined && filter.tc === undefined)
            this.url = "v1/patient_relapse_communications/?offset=" + offset;
        else if (filter.location !== undefined && filter.tc === undefined)
            this.url = "v1/patient_relapse_communications/?location_id=" + filter.location + "&offset=" + offset;
        else if (filter.location === undefined && filter.tc !== undefined)
            this.url = "v1/patient_relapse_communications/?tc_id=" + filter.tc + "&offset=" + offset;
        else
            this.url = "v1/patient_relapse_communications/?location_id=" + filter.location + "&tc_id=" + filter.tc + "&offset=" + offset;
        if (search) {
            this.url = this.url + '&search=' + search;
        }
        if (pageItems) {
            this.url = this.url + '&limit=' + pageItems;
        }
        if (patientId) {
            this.url = this.url + '&patient_file_id=' + patientId;
        }
        if (sortParam && order) {
            this.url = this.url + "&sort=" + sortParam + "&order=" + order;
        }
        return this._basewebservice.request(this.url, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }
    /**
     * Function for handling service call errors
     * @param  {Response|any} error contains error data
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }

    /**
    * Function for send Email
    */
    makeContact(contactData: any, id: any) {
        const data: any = {};
        data.body = contactData;
        return this._basewebservice.request("v1/patient_relapse_communications/" + id + "/contact/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for cancel tracking
     */
    cancelTracking(id: any) {
        const data: any = {};
        data.body = {is_in_follow_up: false};
        return this._basewebservice.request("v1/patient_relapse_communications/" + id + "/untrack/", "put", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    assignBulkTCUpdate(patient: any) {
        this.patient.body = patient;
        return this._basewebservice.request("v1/transfer_treatment_plans/", "patch", this.patient)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for get TCs
     */
    getTCList() {
        return this._basewebservice.request("v1/tc_list/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for get Locations
     */
     getLocationList(req_filter?: boolean) {
        if (req_filter) {
            return this._basewebservice.request("v1/locations/?req_filter=True", "get")
                .map((res: any) => res)
                .catch(this.handleError);
        } else {
            return this._basewebservice.request("v1/locations/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
        }
    }

    /**
     * Function to get patient file history from api.
     * @param  {any} id contains patient id.
     */
    getPatientFile(id: any) {
        return this._basewebservice.request("v1/patient_file/" + id + "/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getChatHistoryUsers(id: any) {
        return this._basewebservice.request("v1/chat/history/patient/" + id + "/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getChatRoomDetails(room_id: any, offset: any, limit: any) {
        return this._basewebservice.request("v1/chat/history/room/" + room_id + "/" + "?offset=" + offset + "&limit=" + limit, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }
}

